'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var DashboardBlastComposed = Joi__default["default"].object().keys({}).description('dashboard:blast_composed event attributes ').meta({
  name: 'DashboardBlastComposed',
  filename: 'dashboard:blast_composed.model'
});
var DashboardBlastComposed$1 = DashboardBlastComposed;

module.exports = DashboardBlastComposed$1;
//# sourceMappingURL=blast_composed.model.js.map
